import React from 'react';
import { CheckIcon, ShieldCheckIcon, ZapIcon, FileTextIcon, LockIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { BuyButton } from './ui/BuyButton';
const INCLUDES = [{
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: FileTextIcon,
  label: 'PDF digital'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CheckIcon,
  label: '7 tomos completos'
}, {
  icon: CheckIcon,
  label: '5 bonos incluidos'
}];
export function Offer() {
  return <section id="comprar" className="w-full scroll-mt-20 bg-cream py-20 sm:py-24" data-id="element-167" data-mp="p1l5h1q4ejvn">
      <div className="mx-auto max-w-3xl px-5" data-id="element-168" data-mp="13xstkd4ng5g7">
        <Reveal data-id="element-169" data-mp="yxy2a8gypdum">
          <div className="overflow-hidden rounded-3xl border border-sand bg-white shadow-2xl shadow-sage-deep/10" data-id="element-170" data-mp="yxes5dxjztr5">
            <div className="bg-clay px-6 py-3 text-center text-sm font-semibold uppercase tracking-widest text-cream" data-id="element-171" data-mp="2fb4zqunvt05j">
              Oferta única de lanzamiento
            </div>

            <div className="p-8 sm:p-10" data-id="element-172" data-mp="pkqoibtcjxat">
              <div className="text-center" data-id="element-173" data-mp="pjpe89k5neu5">
                <h2 className="font-serif text-4xl font-semibold text-ink" data-id="element-174" data-mp="uj1ycmjn67t1">Yoga 360</h2>
                <p className="mt-2 text-muted" data-id="element-175" data-mp="ziesztgr8j66">7 tomos + 5 bonos estratégicos</p>

                <div className="mt-6 flex flex-col items-center" data-id="element-176" data-mp="zgaekhl8c1rn">
                  <span className="text-sm text-muted line-through" data-id="element-177" data-mp="13ip1bcs0rlo7">
                    Precio anterior: $69.990
                  </span>
                  <span className="mt-1 font-serif text-6xl font-semibold text-sage-deep" data-id="element-178" data-mp="6rwii7dpbfiq">
                    $27.990
                  </span>
                  <span className="mt-3 inline-block rounded-full bg-sage/15 px-4 py-1.5 text-sm font-semibold text-sage-deep" data-id="element-179" data-mp="ftcswf4inhmy">
                    Ahorrás $42.000
                  </span>
                </div>
              </div>

              <ul className="mx-auto mt-8 grid max-w-md gap-3 sm:grid-cols-2" data-id="element-180" data-mp="3k8dmwz0ysrps">
                {INCLUDES.map(({
                icon: Icon,
                label
              }) => <li key={label} className="flex items-center gap-2.5 text-sm text-ink/85" data-id="element-181" data-mp="vfh548yeuvjv">
                    <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-sage/12 text-sage-deep" data-id="element-182" data-mp="qgntkm2opemc">
                      <Icon className="h-4 w-4" data-id="element-183" data-mp="154iirshhh0uo" />
                    </span>
                    {label}
                  </li>)}
              </ul>

              <div className="mt-9 flex flex-col items-center" data-id="element-184" data-mp="cgv5kyijlci2">
                <BuyButton className="w-full sm:w-auto" data-id="element-185" data-mp="ch4wcobevnot">
                  Comprar ahora y empezar hoy
                </BuyButton>
                <p className="mt-4 text-xs text-muted" data-id="element-186" data-mp="lhkxhr4omiqi">
                  Mercado Pago · Tarjeta · Compra protegida
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}